import React, { Fragment, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import "./style.css";

const menus = [
  {
    id: 1,
    title: "Home",
    link: "/home",
  },
  {
    id: 88,
    title: "About",
    link: "/about",
  },
  {
    id: 7,
    title: "Products",
    link: "#",
    submenu: [
      {
        id: 71,
        title: "Beds",
        link: "#",
        submenu: [
          {
            id: 711,
            title: "Electric Motor Beds",
            link: "/product/electric-motor-beds",
          },
          {
            id: 712,
            title: "Liposuction Beds",
            link: "/product/liposuction-beds",
          },
          {
            id: 713,
            title: "Manual Beds",
            link: "/product/manual-beds",
          },
        ],
      },
      {
        id: 72,
        title: "Stools",
        link: "#",
        submenu: [
          { id: 721, title: "Dental Stools", link: "/product/dental-stools" },
          { id: 722, title: "Saddle Chairs", link: "/product/saddle-chairs" },
        ],
      },
      {
        id: 75,
        title: "Autoclaves",
        link: "#",
        submenu: [
          { id: 751, title: "UV Sterilizers", link: "/product/uv-sterilizers" },
          { id: 752, title: "Autoclaves", link: "/product/autoclaves" },
        ],
      },
      {
        id: 74,
        title: "Examination Lights",
        link: "/product/examination-lights",
      },
      {
        id: 73,
        title: "Medical Trolleys",
        link: "/product/medical-trolleys",
      }
    ],
  },
  {
    id: 88,
    title: "Contact",
    link: "/contact",
  },
];

const MobileMenu = () => {
  const [openMap, setOpenMap] = useState({});
  const [menuActive, setMenuState] = useState(false);

  const toggleMenu = (id) => {
    setOpenMap((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const renderMenu = (items) => {
    return (
      <ul className="responsivemenu">
        {items.map((item) => {
          const hasChildren =
            Array.isArray(item.submenu) && item.submenu.length > 0;
          const isOpen = !!openMap[item.id];

          return (
            <ListItem key={item.id} className={isOpen ? "active" : ""}>
              {hasChildren ? (
                <Fragment>
                  <div
                    onClick={() => toggleMenu(item.id)}
                    className="menu-toggle"
                    role="button"
                  >
                    {item.title}
                    <i
                      className={
                        isOpen ? "fa fa-angle-up" : "fa fa-angle-down"
                      }
                    ></i>
                  </div>
                  <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    <List className="subMenu">
                      {renderMenu(item.submenu)}
                    </List>
                  </Collapse>
                </Fragment>
              ) : (
                <NavLink
                  onClick={() => {
                    ClickHandler();
                    setMenuState(false);
                  }}
                  className="active"
                  to={item.link}
                >
                  {item.title}
                </NavLink>
              )}
            </ListItem>
          );
        })}
      </ul>
    );
  };

  return (
    <div>
      <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
        <div className="menu-close">
          <div className="clox" onClick={() => setMenuState(!menuActive)}>
            <i className="ti-close"></i>
          </div>
        </div>

        {renderMenu(menus)}
      </div>

      <div
        className="showmenu mobail-menu"
        onClick={() => setMenuState(!menuActive)}
      >
        <button
          type="button"
          className="navbar-toggler open-btn"
          aria-label="Toggle navigation menu"
        >
          <span className="icon-bar first-angle"></span>
          <span className="icon-bar middle-angle"></span>
          <span className="icon-bar last-angle"></span>
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;
